/**
 * GHL Custom Field Configuration
 *
 * Defines all folders and fields to be created in GHL.
 * All fields are created as TEXT type.
 */

export const fieldFolders = [
  {
    folder: "Additional Information",
    fields: [
      "Gender",
      "Suite No/Apt No."
    ]
  },
  {
    folder: "Chief Complaint",
    fields: [
      "In your own words, please briefly describe your main issue or complaint",
      "Primary area of concern",
      "Laterality"
    ]
  },
  {
    folder: "Insurance Information",
    fields: [
      "Primary Insurance Carrier",
      "Primary Policy Number",
      "Primary Group Number",
      "Primary Insurance Phone",
      "Primary Policy Holder Name",
      "Primary Policy Holder DOB",
      "Primary Relation to Patient",
      "Secondary Insurance Carrier",
      "Secondary Policy Number",
      "Secondary Group Number",
      "Secondary Insurance Phone",
      "Secondary Policy Holder Name",
      "Secondary Policy Holder DOB",
      "Secondary Relation to Patient",
      "Tertiary Insurance Carrier",
      "Tertiary Policy Number",
      "Tertiary Group Number",
      "Tertiary Insurance Phone",
      "Tertiary Policy Holder Name",
      "Tertiary Policy Holder DOB",
      "Tertiary Relation to Patient"
    ]
  },
  {
    folder: "Emergency Contact",
    fields: [
      "Emergency Contact Name",
      "Emergency Contact Phone",
      "Emergency Contact Relationship"
    ]
  },
  {
    folder: "Medical History",
    fields: [
      "Current Pain Level",
      "Pain Duration",
      "Pain Type",
      "Pain Frequency",
      "What makes pain worse",
      "What makes pain better",
      "Previous Treatments",
      "Previous Surgeries",
      "Medical Conditions",
      "Current Medications",
      "Allergies",
      "Family Medical History"
    ]
  },
  {
    folder: "Employment Information",
    fields: [
      "Employment Status",
      "Employer Name",
      "Employer Address",
      "Employer Phone",
      "Occupation",
      "Work Injury",
      "Work Injury Date",
      "Workers Comp Claim Number"
    ]
  },
  {
    folder: "Attorney Information",
    fields: [
      "Attorney Name",
      "Attorney Firm",
      "Attorney Phone",
      "Attorney Email",
      "Attorney Address",
      "Case Number"
    ]
  },
  {
    folder: "Accident Information",
    fields: [
      "Accident Type",
      "Accident Date",
      "Accident Location",
      "Accident Description",
      "Police Report Number",
      "At Fault Party"
    ]
  },
  {
    folder: "Pharmacy Information",
    fields: [
      "Pharmacy Name",
      "Pharmacy Address",
      "Pharmacy Phone",
      "Pharmacy Fax"
    ]
  },
  {
    folder: "Referring Physician",
    fields: [
      "Referring Physician Name",
      "Referring Physician Phone",
      "Referring Physician Fax",
      "Referring Physician Address"
    ]
  },
  {
    folder: "Primary Care Physician",
    fields: [
      "PCP Name",
      "PCP Phone",
      "PCP Fax",
      "PCP Address"
    ]
  },
  {
    folder: "Review of Systems",
    fields: [
      "Constitutional Symptoms",
      "Eyes",
      "Ears Nose Throat",
      "Cardiovascular",
      "Respiratory",
      "Gastrointestinal",
      "Genitourinary",
      "Musculoskeletal",
      "Integumentary",
      "Neurological",
      "Psychiatric",
      "Endocrine",
      "Hematologic",
      "Allergic Immunologic"
    ]
  },
  {
    folder: "Social History",
    fields: [
      "Tobacco Use",
      "Alcohol Use",
      "Drug Use",
      "Exercise Frequency",
      "Diet Type",
      "Marital Status",
      "Living Situation"
    ]
  },
  {
    folder: "Consent and Signatures",
    fields: [
      "Patient Signature",
      "Signature Date",
      "Consent for Treatment",
      "HIPAA Acknowledgment",
      "Financial Agreement"
    ]
  },
  {
    folder: "Pain Diagram",
    fields: [
      "Pain Diagram Image",
      "Pain Locations",
      "Pain Intensity by Location"
    ]
  },
  {
    folder: "Imaging and Documents",
    fields: [
      "Previous Imaging Results",
      "Previous Lab Results",
      "Medical Records",
      "Insurance Card Front",
      "Insurance Card Back",
      "Drivers License Front",
      "Drivers License Back"
    ]
  },
  {
    folder: "Appointment Information",
    fields: [
      "Preferred Appointment Time",
      "Preferred Contact Method",
      "How did you hear about us"
    ]
  }
];

/**
 * Get total field count
 * @returns {number} Total number of fields across all folders
 */
export const getTotalFieldCount = () => {
  return fieldFolders.reduce((total, folder) => total + folder.fields.length, 0);
};

/**
 * Get total folder count
 * @returns {number} Total number of folders
 */
export const getTotalFolderCount = () => {
  return fieldFolders.length;
};

export default fieldFolders;
